import {
  Configuration,
  ElectricalContinuityMeasurementApi,
  FavoriteApi,
  FireDetectionApi,
  LightningApi,
  LightningMeasurementApi,
  LightningMeasurementResultApi,
  LowVoltageApi,
  ProjectApi,
  ProjectResultApi,
  ProjectRoleApi,
  RD0WorksApi,
  ReportApi,
  ResultEvaluationApi,
  ResultTypeApi,
  ResultVerificationApi,
  RiskApi,
  RiskyLocalsApi,
  TopicActionPlanApi,
  TopicApi,
  UserProfileApi,
  VisualExaminationApi,
  VisualExaminationResultApi,
  WorkspaceApi,
} from "@socotec.io/rapsotec-back-sdk";
import { useOidcStore } from "vue3-oidc";
import { useLanguageStore } from "@/store/language.js";

const configuration = new Configuration({
  basePath: import.meta.env.VITE_APP_RAPSOTEC_BACK_URL,
  accessToken: () => useOidcStore().state.value.token,
  middleware: [
    {
      pre(context) {
        context.init.headers = {
          ...context.init.headers,
          "Accept-Language": useLanguageStore().lang,
        };
        return { url: context.url, init: context.init };
      },
    },
  ],
});

export const useFavoriteApi = () => new FavoriteApi(configuration);
export const useFireDetectionApi = () => new FireDetectionApi(configuration);
export const useLowVoltageApi = () => new LowVoltageApi(configuration);
export const useRiskApi = () => new RiskApi(configuration);
export const useRiskyLocalsApi = () => new RiskyLocalsApi(configuration);
export const useLightningApi = () => new LightningApi(configuration);
export const useVisualExaminationApi = () =>
  new VisualExaminationApi(configuration);
export const useVisualExaminationResultApi = () =>
  new VisualExaminationResultApi(configuration);
export const useLightningMeasurementApi = () =>
  new LightningMeasurementApi(configuration);
export const useLightningMeasurementResultApi = () =>
  new LightningMeasurementResultApi(configuration);
export const useElectricalContinuityMeasurementApi = () =>
  new ElectricalContinuityMeasurementApi(configuration);
export const useResultTypeApi = () => new ResultTypeApi(configuration);
export const useResultEvaluationApi = () =>
  new ResultEvaluationApi(configuration);
export const useResultVerificationApi = () =>
  new ResultVerificationApi(configuration);
export const useProjectResultApi = () => new ProjectResultApi(configuration);
export const useReportApi = () => new ReportApi(configuration);
export const useProjectApi = () => new ProjectApi(configuration);
export const useProjectRoleApi = () => new ProjectRoleApi(configuration);
export const useRD0WorksApi = () => new RD0WorksApi(configuration);
export const useTopicActionPlanApi = () =>
  new TopicActionPlanApi(configuration);
export const useTopicApi = () => new TopicApi(configuration);
export const useUserProfileApi = () => new UserProfileApi(configuration);
export const useWorkspaceApi = () => new WorkspaceApi(configuration);
